import { AxiosAdapter } from "../commons/adapters";
import { QueryPagination } from "../commons/interfaces";
import { buildQuery } from "../commons/utils/helpers";
import { IAgentesBackendRequestDto } from "../pages/inteligencia-artificial/agentes/interfaces/IAgentesBackend";

const http = new AxiosAdapter();
const BASE_URL = '/v1/agents';

export const getAllAgentsService = async (query?: QueryPagination) => {
    try {
        return await http.get<any>(`${BASE_URL}?${buildQuery(query)}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.error('getAllAgentsService error', error);
    }
}

export const getAgentsFormOptionsService = async () => {
    try {
        return await http.get<any>(`${BASE_URL}/form`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.error('getAgentsFormOptionsService error', error);
    }
}

export const getAgentByIdService = async (id: string) => {
    try {
        return await http.get<any>(`${BASE_URL}/${id}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.error('getAgentByIdService error', error);
    }
}

export const createAgentService = async (data: IAgentesBackendRequestDto) => {
    try {
        return await http.post<any>(BASE_URL, data, null);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.error('createAgentService error', error);
    }
}

export const updateAgentService = async (id: string, data: IAgentesBackendRequestDto) => {
    try {
        return await http.put<any>(`${BASE_URL}/${id}`, data);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.error('updateAgentService error', error);
    }
}

export const deleteAgentService = async (id: string, query?: QueryPagination) => {
    try {
        return await http.deleteTable<any>(`${BASE_URL}/${id}?${buildQuery(query)}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.error('deleteAgentService error', error);
    }
}

export const restoreAgentService = async (id: string, query?: QueryPagination) => {
    try {
        return await http.patchTable<any>(`${BASE_URL}/${id}/restore?${buildQuery(query)}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.error('restoreAgentService error', error);
    }
}
